import dayjs from "dayjs";
import { Paginated } from "../../../../common/domain/models/paginated_models";
import { CentroCustoSecundario } from "../../../rh/domain/models/centro_custo_secundario";
import { Documento } from "../../../rh/domain/models/documento";
import { ArquivoGenericoFilter } from "../../domain/models/arquivo_generico_filter";
import { ArquivoGenericoLista } from "../../domain/models/arquivo_generico_lista";
import { ItemMedicaoTerceirizacaoFilter } from "../../domain/models/config_item_mediacao_filter";
import { ItemMedicaoTerceirizacaoLista } from "../../domain/models/config_item_mediacao_lista";
import { ConfigPagamentoFilter } from "../../domain/models/config_pagamento_filter";
import { ConfigPagamentoLista } from "../../domain/models/config_pagamento_lista";
import { ContratoArquivoFilter } from "../../domain/models/contrato_arquivo_filter";
import { ContratoArquivoLista } from "../../domain/models/contrato_arquivo_lista";
import { ContratoFilter } from "../../domain/models/contrato_filter";
import { ContratoInformacoesFilter } from "../../domain/models/contrato_informacoes_filter";
import { ContratoInformacoesLista } from "../../domain/models/contrato_informacoes_lista";
import { ContratoLista } from "../../domain/models/contrato_lista";
import { ContratoServicoFilter } from "../../domain/models/contrato_servico_filter";
import { ContratoServicoLista } from "../../domain/models/contrato_servico_lista";
import { FuncionarioTercFilter } from "../../domain/models/funcionario_terc_filter";
import { FuncionarioTercLista } from "../../domain/models/funcionarios_tercerizado_lista";
import { MedicaoTerceirizacaoFilter } from "../../domain/models/medicao_terceirizacao_filter";
import { MedicaoTerceirizacaoLista } from "../../domain/models/medicao_terceirizacao_lista";
import { ITerceirizacaoRepository } from "../../domain/repositories/terceirizacao_repository";
import { CreateContratoResponse } from "../daos/create/create_contrato";
import { CreatFuncionariosTercResponse } from "../daos/create/create_funcionarios_terc";
import { CreatMedicaoResponse } from "../daos/create/create_medicao";
import { ITerceirizacaoService } from "../services/terceirizacao_service";
import { FuncionarioTreinamento } from "../../../rh/domain/models/funcionario_treinamento";
import { AvaliacaoTreinamento } from "../../../rh/domain/models/avaliacao_treinamento";
import { TreinamentoFuncionario } from "../../../rh/domain/models/treinamento_funcionario";
import { AvaliacaoOrdemCompra } from "../../../compras/domain/models/avaliacao_ordem_compra";
import { AvaliacaoOrdemFornecimento } from "../../domain/models/avaliacao_ordem_compra";
import { FormularioAvaliacaoLista } from "../../domain/models/formulario_avaliacao_lista";
import { TreinamentoFuncionarioData } from "../../../rh/domain/models/treinamento_funcionario_data";
import { TreinamentoFuncionarioInstrutor } from "../../../rh/domain/models/treinamento_funcionario_instrutor";
import { TreinamentoFuncionarioLocal } from "../../../rh/domain/models/treinamento_funcionario_local";
import { DownloadFuncionarioDocumento } from "../../../rh/domain/models/download_funcionario_documento";
import { TercIndicadores } from "../../domain/models/terc_indicadores";

export class TerceirizacaoRepository implements ITerceirizacaoRepository {
  constructor(private readonly service: ITerceirizacaoService) {}

  async getAllListagemContrato(
    filter: ContratoFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ContratoLista>> {
    const response = await this.service.getAllListagemContrato({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ContratoLista => ({
          IdCentroCusto: item.idCentroCusto,
          ContratoAssinado: item.contratoAssinado,
          DataAte: item.dataAte,
          DataDe: item.dataDe,
          Escopo: item.escopo,
          IdContrato: item.idContrato,
          IdFornecedor: item.idFornecedor,
          NumeroContrato: item.numeroContrato,
          NomeFornecedor: item.nomeFornecedor,
          Status: item.status,
          StatusPcmat: item.statusPcmat,
          StatusPcmso: item.statusPcmso,
          NomeCentroCusto: item.nomeCentroCusto,
          ValorContrato: item.valorContrato,
          ValorMedido: item.valorMedido,
          ValorRestante: item.valorRestante,
          StatusDocumento: item.statusDocumento,
          Medicoes: Array.isArray(item.medicoes)
          ? item.medicoes.map((m: any) => ({
              Status: m.status,
              PgtoProvisionado: m.pgtoProvisionado,
              NrMedicao: m.nrMedicao,
              DataMedicao: m.dataMedicao,
              ValorTotal: m.valorTotal ?? 0,
              ValorRetencao: m.valorRetencao ?? 0,
            }))
          : [],
        }),
      ),
    };
  }
  async createContrato(
    Status: number | null,
    NumeroContrato: string | null,
    Escopo: string | null,
    DataDe: Date | null,
    DataAte: Date | null,
    IdCentroCusto: number | null,
    IdFornecedor: number | null,
    StatusPcmat: number | null,
    StatusPcmso: number | null,
    ValorContrato: number | null,
    ValorMedido: number | null,
    ValorRestante: number | null,
    ContratoAssinado?: string | null,
  ): Promise<CreateContratoResponse> {
    const response = await this.service.createContrato({
      Status,
      NumeroContrato,
      Escopo,
      DataDe,
      DataAte,
      IdCentroCusto,
      IdFornecedor,
      StatusPcmat,
      StatusPcmso,
      ValorContrato,
      ValorMedido,
      ValorRestante,
      ContratoAssinado,
    });
    return response;
  }
  async updateContrato(
    IdContrato: number,
    Status: number | null,
    NumeroContrato: string | null,
    Escopo: string | null,
    DataDe: Date | null,
    DataAte: Date | null,
    IdCentroCusto: number | null,
    IdFornecedor: number | null,
    StatusPcmat: number | null,
    StatusPcmso: number | null,
    ValorContrato: number | null,
    ValorMedido: number | null,
    ValorRestante: number | null,
    ContratoAssinado?: string | null,
  ): Promise<void> {
    await this.service.updateContrato({
      IdContrato,
      Status,
      NumeroContrato,
      Escopo,
      DataDe,
      DataAte,
      IdCentroCusto,
      IdFornecedor,
      StatusPcmat,
      StatusPcmso,
      ValorContrato,
      ValorMedido,
      ValorRestante,
      ContratoAssinado,
    });
  }
  async deleteContrato(IdContrato: number): Promise<void> {
    await this.service.deleteContrato({ IdContrato });
  }

  //#region Servico
  async getAllListagemContratoServico(
    filter: ContratoServicoFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ContratoServicoLista>> {
    const response = await this.service.getAllListagemContratoServico({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ContratoServicoLista => ({
          Detalhamento: item.detalhamento,
          IdContrato: item.idContrato,
          IdContratoServico: item.idContratoServico,
          IdProdutoServico: item.idProdutoServico,
          Quantidade: item.quantidade,
          ValorTotal: item.valorTotal,
          ValorUnitario: item.valorUnitario,
          NomeProdutoServico: item.nomeProdutoServico,
          Unidade: item.unidade,
          Total: item.total,
          ValorMedido: item.valorMedido,
        }),
      ),
    };
  }
  async createContratoServico(
    IdContrato: number,
    IdProdutoServico: number,
    Detalhamento: string | null,
    Quantidade: number | null,
    ValorUnitario: number | null,
    ValorTotal: number | null,
  ): Promise<void> {
    await this.service.createContratoServico({
      IdContrato,
      IdProdutoServico,
      Detalhamento,
      Quantidade,
      ValorUnitario,
      ValorTotal,
    });
  }
  async updateContratoServico(
    IdContratoServico: number,
    IdContrato: number,
    IdProdutoServico: number,
    Detalhamento: string | null,
    Quantidade: number | null,
    ValorUnitario: number | null,
    ValorTotal: number | null,
  ): Promise<void> {
    await this.service.updateContratoServico({
      IdContratoServico,
      IdContrato,
      IdProdutoServico,
      Detalhamento,
      Quantidade,
      ValorUnitario,
      ValorTotal,
    });
  }
  async deleteContratoServico(IdContratoServico: number): Promise<void> {
    await this.service.deleteContratoServico({ IdContratoServico });
  }

  //#endregion

  //#region Arquivo
  async getAllListagemContratoArquivo(
    filter: ContratoArquivoFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ContratoArquivoLista>> {
    const response = await this.service.getAllListagemContratoArquivo({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ContratoArquivoLista => ({
          Arquivo: item.arquivo,
          DataVencimento: item.dataVencimento,
          Descricao: item.descricao,
          IdContrato: item.idContrato,
          IdContratoArquivo: item.idContratoArquivo,
          Nome: item.nome,
          Obsoleto: item.obsoleto,
        }),
      ),
    };
  }
  async createContratoArquivo(
    IdContrato: number,
    Descricao: string | null,
    Nome: string | null,
    Arquivo: File | null,
    Obsoleto: number | null,
    DataVencimento: Date | null,
  ): Promise<void> {
    await this.service.createContratoArquivo({
      IdContrato,
      Descricao,
      Nome,
      Arquivo,
      Obsoleto,
      DataVencimento,
    });
  }
  async updateContratoArquivo(
    IdContratoArquivo: number,
    IdContrato: number,
    Descricao: string | null,
    Nome: string | null,
    Arquivo: File | null,
    Obsoleto: number | null,
    DataVencimento: Date | null,
    limparArquivo1: boolean | null,
  ): Promise<void> {
    await this.service.updateContratoArquivo({
      IdContratoArquivo,
      IdContrato,
      Descricao,
      Nome,
      Arquivo,
      Obsoleto,
      DataVencimento,
      limparArquivo1
    });
  }
  async deleteContratoArquivo(IdContratoArquivo: number): Promise<void> {
    await this.service.deleteContratoArquivo({ IdContratoArquivo });
  }

  //#endregion

  //#region Informacoes
  async getAllListagemContratoInformacoes(
    filter: ContratoInformacoesFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ContratoInformacoesLista>> {
    const response = await this.service.getAllListagemContratoInformacoes({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ContratoInformacoesLista => ({
          Data: item.data,
          DescInformacoes: item.descInformacoes,
          IdContrato: item.idContrato,
          IdContratoInformacoes: item.idContratoInformacoes,
          IdFuncionario: item.idFuncionario,
          Responsavel: item.responsavel,
          NomeFuncionario: item.nomeFuncionario,
        }),
      ),
    };
  }
  async createContratoInformacoes(
    IdContrato: number,
    DescInformacoes: string | null,
    Responsavel: string | null,
    IdFuncionario: number | null,
    Data: Date | null,
  ): Promise<void> {
    await this.service.createContratoInformacoes({
      IdContrato,
      DescInformacoes,
      Responsavel,
      IdFuncionario,
      Data,
    });
  }
  async updateContratoInformacoes(
    IdContratoInformacoes: number,
    IdContrato: number,
    DescInformacoes: string | null,
    Responsavel: string | null,
    IdFuncionario: number | null,
    Data: Date | null,
  ): Promise<void> {
    await this.service.updateContratoInformacoes({
      IdContratoInformacoes,
      IdContrato,
      DescInformacoes,
      Responsavel,
      IdFuncionario,
      Data,
    });
  }
  async deleteContratoInformacoes(
    IdContratoInformacoes: number,
  ): Promise<void> {
    await this.service.deleteContratoInformacoes({ IdContratoInformacoes });
  }
  //#endregion

  //#region Medicao
  async getAllListagemMedicao(
    filter: MedicaoTerceirizacaoFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<MedicaoTerceirizacaoLista>> {
    const response = await this.service.getAllListagemMedicao({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): MedicaoTerceirizacaoLista => ({
          Acrescimo: item.acrescimo,
          DataAte: item.dataAte,
          DataDe: item.dataDe,
          DataMedicao: item.dataMedicao,
          Desconto: item.desconto,
          Descricao: item.descricao,
          Entregue: item.entregue,
          FornecedorAvaliado: item.fornecedorAvaliado,
          IdContrato: item.idContrato,
          IdFuncionarioResp: item.idFuncionarioResp,
          IdMedicaoTerceirizacao: item.idMedicaoTerceirizacao,
          IdSubconta: item.idSubconta,
          Imposto: item.imposto,
          InformacoesGerais: item.informacoesGerais,
          NotaFiscalEntregue: item.notaFiscalEntregue,
          NrMedicaoTerceirizacao: item.nrMedicaoTerceirizacao,
          NrNotaFiscal: item.nrNotaFiscal,
          NroNotaFiscal: item.nroNotaFiscal,
          PercRetencao: item.percRetencao,
          PgtoProvisionado: item.pgtoProvisionado,
          Status: item.status,
          ValorRetencao: item.valorRetencao,
          NomeContrato: item.nomeContrato,
          NomeFuncionario: item.nomeFuncionario,
          NomeCentroCusto: item.nomeCentroCusto,
          NomeFornecedor: item.nomeFornecedor,
          NumeroContrato: item.numeroContrato,
          ValorMedicao: item.valorMedicao,
          SubTotal: item.subTotal,
          ValorTotalCalculado: item.valorTotalCalculado,
        }),
      ),
    };
  }
  async deleteMedicao(IdMedicaoTerceirizacao: number): Promise<void> {
    await this.service.deleteMedicao({ IdMedicaoTerceirizacao });
  }
  async createMedicao(
    NrMedicaoTerceirizacao: number | null,
    IdContrato: number,
    DataMedicao: Date | null,
    DataDe: Date | null,
    DataAte: Date | null,
    IdFuncionarioResp: number | null,
    Imposto: number | null,
    Acrescimo: number | null,
    Desconto: number | null,
    PercRetencao: number | null,
    ValorRetencao: number | null,
    InformacoesGerais: string | null,
    Status: number | null,
    PgtoProvisionado: boolean | null,
    FornecedorAvaliado: boolean | null,
    Entregue: boolean | null,
    NotaFiscalEntregue: number | null,
    NroNotaFiscal: string | null,
    NrNotaFiscal: string | null,
    IdSubconta: number | null,
    Descricao: string | null,
  ): Promise<CreatMedicaoResponse> {
    const response = await this.service.createMedicao({
      NrMedicaoTerceirizacao,
      IdContrato,
      DataMedicao,
      DataDe,
      DataAte,
      IdFuncionarioResp,
      Imposto,
      Acrescimo,
      Desconto,
      PercRetencao,
      ValorRetencao,
      InformacoesGerais,
      Status,
      PgtoProvisionado,
      FornecedorAvaliado,
      Entregue,
      NotaFiscalEntregue,
      NroNotaFiscal,
      NrNotaFiscal,
      IdSubconta,
      Descricao,
    });
    return response;
  }
  async updateMedicao(
    IdMedicaoTerceirizacao: number,
    NrMedicaoTerceirizacao: number | null,
    IdContrato: number,
    DataMedicao: Date | null,
    DataDe: Date | null,
    DataAte: Date | null,
    IdFuncionarioResp: number | null,
    Imposto: number | null,
    Acrescimo: number | null,
    Desconto: number | null,
    PercRetencao: number | null,
    ValorRetencao: number | null,
    InformacoesGerais: string | null,
    Status: number | null,
    PgtoProvisionado: boolean | null,
    FornecedorAvaliado: boolean | null,
    Entregue: boolean | null,
    NotaFiscalEntregue: number | null,
    NroNotaFiscal: string | null,
    NrNotaFiscal: string | null,
    IdSubconta: number | null,
    Descricao: string | null,
  ): Promise<void> {
    await this.service.updateMedicao({
      IdMedicaoTerceirizacao,
      NrMedicaoTerceirizacao,
      IdContrato,
      DataMedicao,
      DataDe,
      DataAte,
      IdFuncionarioResp,
      Imposto,
      Acrescimo,
      Desconto,
      PercRetencao,
      ValorRetencao,
      InformacoesGerais,
      Status,
      PgtoProvisionado,
      FornecedorAvaliado,
      Entregue,
      NotaFiscalEntregue,
      NroNotaFiscal,
      NrNotaFiscal,
      IdSubconta,
      Descricao,
    });
  }
  //#endregion

  //#region ArquivoGenerico
  async getAllListagemArquivoGenerico(
    filter: ArquivoGenericoFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ArquivoGenericoLista>> {
    const response = await this.service.getAllListagemArquivoGenerico({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ArquivoGenericoLista => ({
          Arquivo1: item.arquivo1,
          Arquivo2: item.arquivo2,
          Arquivo3: item.arquivo3,
          IdArquivoGenerico1: item.idArquivoGenerico1,
          IdArquivoGenerico2: item.idArquivoGenerico2,
          IdArquivoGenerico3: item.idArquivoGenerico3,
          IdTabela: item.idTabela,
          NomeArquivo1: item.nomeArquivo1,
          NomeArquivo2: item.nomeArquivo2,
          NomeArquivo3: item.nomeArquivo3,
          Ordem: item.ordem,
          TipoTabela: item.tipoTabela,
        }),
      ),
    };
  }
  async createArquivoGenerico(
    IdTabela: number | null,
    NomeArquivo1: string | null,
    Arquivo1: string | null,
    NomeArquivo2: string | null,
    Arquivo2: string | null,
    NomeArquivo3: string | null,
    Arquivo3: string | null,
    Ordem: number | null,
    TipoTabela: number | null,
  ): Promise<void> {
    await this.service.createArquivoGenerico({
      IdTabela,
      NomeArquivo1,
      Arquivo1,
      NomeArquivo2,
      Arquivo2,
      NomeArquivo3,
      Arquivo3,
      Ordem,
      TipoTabela,
    });
  }
  async updateArquivoGenerico(
    IdArquivoGenerico1: number | null,
    IdArquivoGenerico2: number | null,
    IdArquivoGenerico3: number | null,
    IdTabela: number | null,
    NomeArquivo1: string | null,
    Arquivo1: string | null,
    NomeArquivo2: string | null,
    Arquivo2: string | null,
    NomeArquivo3: string | null,
    Arquivo3: string | null,
    Ordem: number | null,
    TipoTabela: number | null,
  ): Promise<void> {
    await this.service.updateArquivoGenerico({
      IdArquivoGenerico1,
      IdArquivoGenerico2,
      IdArquivoGenerico3,
      IdTabela,
      NomeArquivo1,
      Arquivo1,
      NomeArquivo2,
      Arquivo2,
      NomeArquivo3,
      Arquivo3,
      Ordem,
      TipoTabela,
    });
  }
  //#endregion

  //#region ConfigPagamento
  async getAllListagemConfigPagamento(
    filter: ConfigPagamentoFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ConfigPagamentoLista>> {
    const response = await this.service.getAllListagemConfigPagamento({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ConfigPagamentoLista => ({
          AVista: item.aVista,
          DataEntrada: item.dataEntrada,
          DataPgto: item.dataPgto,
          FormaPagamento: item.formaPagamento,
          IdMedicaoTerceirizacao: item.idMedicaoTerceirizacao,
          IdPgtoMedicao: item.idPgtoMedicao,
          IdSubconta: item.idSubconta,
          IdTipoConta: item.idTipoConta,
          InformacoesGerais: item.informacoesGerais,
          Nome: item.nome,
          NrNotaFiscalEspecial: item.nrNotaFiscalEspecial,
          NroDias: item.nroDias,
          NrParcelas: item.nrParcelas,
          Observacao: item.observacao,
          TipoData: item.tipoData,
          ValorEntrada: item.valorEntrada,
          ValorTotal: item.valorTotal,
          NomeFornecedor: item.nomeFornecedor,
        }),
      ),
    };
  }

  async createConfigPagamento(
    IdMedicaoTerceirizacao: number | null,
    Nome: string | null,
    AVista: number | null,
    NrParcelas: number | null,
    TipoData: number | null,
    NroDias: number | null,
    ValorTotal: number | null,
    DataPgto: Date | null,
    IdTipoConta: number | null,
    FormaPagamento: string | null,
    Observacao: string | null,
    InformacoesGerais: string | null,
    NrNotaFiscalEspecial: string | null,
    ValorEntrada: number | null,
    DataEntrada: Date | null,
    IdSubconta: number | null,
    DiasEntreParcelas: number | null,
  ): Promise<void> {
    await this.service.createConfigPagamento({
      IdMedicaoTerceirizacao,
      Nome,
      AVista,
      NrParcelas,
      TipoData,
      NroDias,
      ValorTotal,
      DataPgto,
      IdTipoConta,
      FormaPagamento,
      Observacao,
      InformacoesGerais,
      NrNotaFiscalEspecial,
      ValorEntrada,
      DataEntrada,
      IdSubconta,
      DiasEntreParcelas,
    });
  }

  async updateConfigPagamento(
    IdPgtoMedicao: number,
    IdMedicaoTerceirizacao: number | null,
    Nome: string | null,
    AVista: number | null,
    NrParcelas: number | null,
    TipoData: number | null,
    NroDias: number | null,
    ValorTotal: number | null,
    DataPgto: Date | null,
    IdTipoConta: number | null,
    FormaPagamento: string | null,
    Observacao: string | null,
    InformacoesGerais: string | null,
    NrNotaFiscalEspecifica: string | null,
    ValorEntrada: number | null,
    DataEntrada: Date | null,
    IdSubconta: number | null,
  ): Promise<void> {
    await this.service.updateConfigPagamento({
      IdPgtoMedicao,
      IdMedicaoTerceirizacao,
      Nome,
      AVista,
      NrParcelas,
      TipoData,
      NroDias,
      ValorTotal,
      DataPgto,
      IdTipoConta,
      FormaPagamento,
      Observacao,
      InformacoesGerais,
      NrNotaFiscalEspecifica,
      ValorEntrada,
      DataEntrada,
      IdSubconta,
    });
  }
  async deleteConfigPagamento(idPgtoMedicao: number): Promise<void> {
    await this.service.deleteConfigPagamento({ idPgtoMedicao });
  }

  //#endregion

  //#region ItemMedicao
  async getAllListagemItemMedicao(
    filter: ItemMedicaoTerceirizacaoFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ItemMedicaoTerceirizacaoLista>> {
    const response = await this.service.getAllListagemItemMedicao({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ItemMedicaoTerceirizacaoLista => ({
          IdItemMedicaoTerceirizacao: item.idItemMedicaoTerceirizacao,
          IdMedicaoTerceirizacao: item.idMedicaoTerceirizacao,
          IdProdutoServico: item.idProdutoServico,
          IdSubconta: item.idSubconta,
          Detalhamento: item.detalhamento,
          Quantidade: item.quantidade,
          ValorUnitario: item.valorUnitario,
          ValorTotal: item.valorTotal,
          NomeProdutoServico: item.nomeProdutoServico,
          NomeSubConta: item.nomeSubConta,
          Unidade: item.unidade,
        }),
      ),
    };
  }
  async createItemMedicao(
    IdMedicaoTerceirizacao: number | null,
    IdProdutoServico: number | null,
    IdSubconta: number | null,
    Detalhamento: string | null,
    Quantidade: number | null,
    ValorUnitario: number | null,
    ValorTotal: number | null,
  ): Promise<void> {
    await this.service.createItemMedicao({
      IdMedicaoTerceirizacao,
      IdProdutoServico,
      IdSubconta,
      Detalhamento,
      Quantidade,
      ValorUnitario,
      ValorTotal,
    });
  }

  async updateItemMedicao(
    IdItemMedicaoTerceirizacao: number,
    IdMedicaoTerceirizacao: number | null,
    IdProdutoServico: number | null,
    IdSubconta: number | null,
    Detalhamento: string | null,
    Quantidade: number | null,
    ValorUnitario: number | null,
    ValorTotal: number | null,
  ): Promise<void> {
    await this.service.updateItemMedicao({
      IdItemMedicaoTerceirizacao,
      IdMedicaoTerceirizacao,
      IdProdutoServico,
      IdSubconta,
      Detalhamento,
      Quantidade,
      ValorUnitario,
      ValorTotal,
    });
  }

  async deleteItemMedicao(IdItemMedicaoTerceirizacao: number): Promise<void> {
    await this.service.deleteItemMedicao({ IdItemMedicaoTerceirizacao });
  }

  //#endregion

  //#region Medicao Entrega
  async getAllListagemMedicaoEntrega(
    filter: MedicaoTerceirizacaoFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<MedicaoTerceirizacaoLista>> {
    const response = await this.service.getAllListagemMedicaoEntrega({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): MedicaoTerceirizacaoLista => ({
          Acrescimo: item.acrescimo,
          DataAte: item.dataAte,
          DataDe: item.dataDe,
          DataMedicao: item.dataMedicao,
          Desconto: item.desconto,
          Descricao: item.descricao,
          Entregue: item.entregue,
          FornecedorAvaliado: item.fornecedorAvaliado,
          IdContrato: item.idContrato,
          IdFuncionarioResp: item.idFuncionarioResp,
          IdMedicaoTerceirizacao: item.idMedicaoTerceirizacao,
          IdSubconta: item.idSubconta,
          Imposto: item.imposto,
          InformacoesGerais: item.informacoesGerais,
          NotaFiscalEntregue: item.notaFiscalEntregue,
          NrMedicaoTerceirizacao: item.nrMedicaoTerceirizacao,
          NrNotaFiscal: item.nrNotaFiscal,
          NroNotaFiscal: item.nroNotaFiscal,
          PercRetencao: item.percRetencao,
          PgtoProvisionado: item.pgtoProvisionado,
          Status: item.status,
          ValorRetencao: item.valorRetencao,
          NomeContrato: item.nomeContrato,
          NomeFuncionario: item.nomeFuncionario,
          NomeCentroCusto: item.nomeCentroCusto,
          NomeFornecedor: item.nomeFornecedor,
          NumeroContrato: item.numeroContrato,
          ValorMedicao: item.valorMedicao,
          SubTotal: item.subTotal,
          ValorTotalCalculado: item.valorTotalCalculado,
          DataAvaliacao: item.dataAvaliacao,
          NomeAvaliador: item.nomeAvaliador,
        }),
      ),
    };
  }

  async getAvaliacaoFornecedor(
    IdMedicaoTerceirizacao: number,
  ): Promise<AvaliacaoOrdemFornecimento | null> {
    const response = await this.service.getAvaliacaoFornecedor({
      IdMedicaoTerceirizacao,
    });
    return response.item;
  }

  async getAllFormularioAvaliacao(
    IdMedicaoTerceirizacao: number,
  ): Promise<FormularioAvaliacaoLista | null> {
    const response = await this.service.getAllFormularioAvaliacao({
      IdMedicaoTerceirizacao,
    });

    return {
      Data: response.item.data,
      Entregue: response.item.entregue === true ? 1 : 0,
      NrMedicaoTerceirizacao: response.item.nrMedicaoTerceirizacao,
      NroNotaFiscal: response.item.nroNotaFiscal,
      NroNotaFiscalEntregue: response.item.nroNotaFiscalEntregue,
      IdFuncionarioAvaliador: response.item.idFuncionarioAvaliador,
      Observacao: response.item.observacao,
    };
  }
  async updateAvaliacao(
    IdMedicaoTerceirizacao: number,
    Entregue: number,
    NroNotaFiscalEntregue: number,
    data: Date,
    IdFuncionarioAvaliador: number | null,
    NroNotaFiscal: string | null,
    Observacao: string | null,
    criterioItems: {
      idCriterioAvaliacaoFornecedor: number;
      idItemAvaliacaoFornecedor: number | null;
      nota: number | null;
    }[],
  ): Promise<void> {
    await this.service.updateAvaliacao({
      IdMedicaoTerceirizacao,
      Entregue,
      NroNotaFiscalEntregue,
      data,
      IdFuncionarioAvaliador,
      NroNotaFiscal,
      Observacao,
      criterioItems,
    });
  }
  //#endregion

  //#region FuncionarioTerc
  async getAllListagemFuncionarioTerc(
    filter: FuncionarioTercFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<FuncionarioTercLista>> {
    const response = await this.service.getAllListagemFuncionarioTerc({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): FuncionarioTercLista => ({
          Agencia: item.agencia,
          AnotacoesDocumentos: item.anotacoesDocumentos,
          AnotacoesGerais: item.anotacoesGerais,
          Ativo: item.ativo,
          Calca: item.calca,
          Calcado: item.calcado,
          Camisa: item.camisa,
          Cpf: item.cpf,
          Ctps: item.ctps,
          CtpsUf: item.ctpsUf,
          DataAdmissao: item.dataAdmissao,
          DataDemissao: item.dataDemissao,
          DataEmissao: item.dataEmissao,
          DataExpedicao: item.dataExpedicao,
          DataInicio: item.dataInicio,
          DataNascimento: item.datanascimento,
          DataTermino: item.dataTermino,
          DescontoSindical: item.descontoSindical,
          Digito: item.digito,
          Email: item.email,
          Estado: item.estado,
          EstadoCivil: item.estadoCivil,
          Experiencia: item.experiencia,
          ExtensaoFoto: item.extensaoFoto,
          HorarioAlmoco: item.horarioAlmoco,
          HorarioTrabalho: item.horarioTrabalho,
          IdCargo: item.idCargo,
          IdCentroCusto: item.idCentroCusto,
          IdEndereco: item.idEndereco,
          IdFornecedor: item.idFornecedor,
          IdFuncionarioTerc: item.idFuncionarioTerc,
          IdMotivoDemissao: item.idMotivoDemissao,
          Imagem: item.imagem,
          LocalNascimento: item.localNascimento,
          Nacionalidade: item.nacionalidade,
          Naturalidade: item.naturalidade,
          Nome: item.nome,
          NomeBanco: item.nomeBanco,
          NomeMae: item.nomeMae,
          NomePai: item.nomePai,
          NrConta: item.nrConta,
          NrNumeroFuncionario: item.nrNumeroFuncionario,
          Observacoes: item.observacoes,
          Operacao: item.operacao,
          OrgExp: item.orgExp,
          Periodo: item.periodo,
          Pis: item.pis,
          ProrrogarEm: item.prorrogarEm,
          Reservista: item.reservista,
          Rg: item.rg,
          RgUf: item.rgUf,
          Salario: item.salario,
          Serie: item.serie,
          Sexo: item.sexo,
          Situacao: item.situacao,
          StatusAso: item.statusAso,
          TelCelular: item.telCelular,
          TelFixo: item.telFixo,
          TempoExperiencia: item.tempoExperiencia,
          TipoConta: item.tipoConta,
          TituloEleitor: item.tituloEleitor,
          Zona: item.zona,
          Documentos: item.documentos,
          Treinamentos: item.treinamentos,
          NomeCargo: item.nomeCargo,
          NomeFornecedor: item.nomeFornecedor,
          NomeCentroCusto: item.nomeCentroCusto,
          Apartamento: item.apartamento,
          Bairro: item.bairro,
          Cep: item.cep,
          Cidade: item.cidade,
          Numero: item.numero,
          Pais: item.pais,
          Rua: item.rua,
          Uf: item.uf,
        }),
      ),
    };
  }
  async alterarInativoAtivoFuncionarios(
    Ativo: number,
    DataTermino: Date | null,
    funcionarios: number[],
  ): Promise<void> {
    await this.service.alterarInativoAtivoFuncionarios({
      Ativo,
      DataTermino,
      funcionarios,
    });
  }
  async deleteFuncionariosTerc(IdFuncionarioTerc: number): Promise<void> {
    await this.service.deleteFuncionariosTerc({ IdFuncionarioTerc });
  }
  async createFuncionariosTerc(
    Ativo: boolean | null,
    Nome: string,
    IdCentroCusto: number | null,
    IdCargo: number | null,
    IdFornecedor: number | null,
    DataInicio: string | Date | null,
    DataTermino: string | Date | null,
    StatusAso: number | null,
    Salario: number | null,
    Cpf: string | null,
    Ctps: string | null,
    Serie: string | null,
    CtpsUf: string | null,
    DataEmissao: string | Date | null,
    RgUf: string | null,
    DataExpedicao: string | Date | null,
    OrgExp: string | null,
    Imagem: string | null,
    ExtensaoFoto: string | null,
    Observacoes: string | null,
    //Endereco
    Rua: string | null,
    Numero: string | null,
    Apartamento: string | null,
    Cep: string | null,
    Uf: string | null,
    Cidade: string | null,
    Bairro: string | null,
    Pais: string | null,
    dataNascimento: Date | null
  ): Promise<CreatFuncionariosTercResponse> {
    const response = await this.service.createFuncionariosTerc({
      Ativo,
      Nome,
      IdCentroCusto,
      IdCargo,
      IdFornecedor,
      DataInicio,
      DataTermino,
      StatusAso,
      Salario,
      Cpf,
      Ctps,
      Serie,
      CtpsUf,
      DataEmissao,
      RgUf,
      DataExpedicao,
      OrgExp,
      Imagem,
      ExtensaoFoto,
      Observacoes,
      Rua,
      Numero,
      Apartamento,
      Cep,
      Uf,
      Cidade,
      Bairro,
      Pais,
      dataNascimento
    });

    return response;
  }
  async updateFuncionariosTerc(
    IdFuncionarioTerc: number,
    Ativo: boolean | null,
    Nome: string,
    IdCentroCusto: number | null,
    IdCargo: number | null,
    IdFornecedor: number | null,
    DataInicio: string | Date | null,
    DataTermino: string | Date | null,
    StatusAso: number | null,
    Salario: number | null,
    Cpf: string | null,
    Ctps: string | null,
    Serie: string | null,
    CtpsUf: string | null,
    DataEmissao: string | Date | null,
    RgUf: string | null,
    DataExpedicao: string | Date | null,
    OrgExp: string | null,
    Imagem: string | null,
    ExtensaoFoto: string | null,
    Observacoes: string | null,
    //Endereco
    Rua: string | null,
    Numero: string | null,
    Apartamento: string | null,
    Cep: string | null,
    Uf: string | null,
    Cidade: string | null,
    Bairro: string | null,
    Pais: string | null,
    dataNascimento: Date | null
  ): Promise<void> {
    await this.service.updateFuncionariosTerc({
      IdFuncionarioTerc,
      Ativo,
      Nome,
      IdCentroCusto,
      IdCargo,
      IdFornecedor,
      DataInicio,
      DataTermino,
      StatusAso,
      Salario,
      Cpf,
      Ctps,
      Serie,
      CtpsUf,
      DataEmissao,
      RgUf,
      DataExpedicao,
      OrgExp,
      Imagem,
      ExtensaoFoto,
      Observacoes,
      Rua,
      Numero,
      Apartamento,
      Cep,
      Uf,
      Cidade,
      Bairro,
      Pais,
      dataNascimento
    });
  }
  async createCentroCustoSecundario(
    idFuncionario: number,
    idCentroCusto: number,
  ): Promise<void> {
    await this.service.createCentroCustoSecundario({
      idFuncionario,
      idCentroCusto,
    });
  }

  async updateCentroCustoSecundario(
    idFuncionarioCentroCusto: number,
    idCentroCusto: number,
  ): Promise<void> {
    await this.service.updateCentroCustoSecundario({
      idFuncionarioCentroCusto,
      idCentroCusto,
    });
  }
  async getCentroCustoSecundarios(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<CentroCustoSecundario>> {
    const response = await this.service.getCentroCustoSecundarios({
      idFuncionario,
      page,
      pageSize,
    });
    return { ...response };
  }
  async deleteCentroCustoSecundario(
    idCentroCustoSecundario: number,
  ): Promise<void> {
    await this.service.deleteCentroCustoSecundario({ idCentroCustoSecundario });
  }

  async getDocumentos(
    idFuncionario: number,
    page: number,
    pageSize: number,
    status?: number,
    situacao?: number,
    DataDe?: string | Date | null,
    DataAte?: string | Date | null,
    NomeDocumento?: string | null,
  ): Promise<Paginated<Documento>> {
    const response = await this.service.getDocumentos({
      idFuncionario,
      page,
      pageSize,
      status,
      situacao,
      DataDe,
      DataAte,
      NomeDocumento,
    });
    return {
      ...response,
      items: response.items.map(
        (x): Documento => ({
          idDocumento: x.idFuncionarioArquivo,
          status: x.obsoleto === true ? 1 : 0,
          situacao: x.obsoleto === true ? 1 : 0,
          dataVencimento: x.dataVencimento
            ? dayjs(x.dataVencimento).toDate()
            : null,
          dataEmissao: null,
          descricao: x.descricao ?? "",
          nome: x.nome,
        }),
      ),
    };
  }

  async createDocumento(
    idFuncionario: number,
    nomeDocumento: string,
    statusArquivo: number | null,
    dataVencimento: Date | null,
    arquivoNome: string | null,
    arquivo: File | null,
  ): Promise<void> {
    await this.service.createDocumento({
      idFuncionario,
      nomeDocumento,
      statusArquivo,
      dataVencimento,
      arquivoNome,
      arquivo,
    });
  }

  async updateDocumento(
    idFuncionarioDocumento: number,
    nomeDocumento: string,
    statusArquivo: number | null,
    dataVencimento: Date | null,
    arquivoNome: string | null,
    arquivo: File | null,
    limparArquivo: boolean,
  ): Promise<void> {
    await this.service.updateDocumento({
      idFuncionarioDocumento,
      nomeDocumento,
      statusArquivo,
      dataVencimento,
      arquivoNome,
      arquivo,
      limparArquivo,
    });
  }

  async deleteDocumento(idDocumento: number): Promise<void> {
    await this.service.deleteDocumento({ idDocumento });
  }
  async downloadFuncionarioDocumentoById(
    idFuncionarioArquivo: number,
  ): Promise<Blob> {
    const response = await this.service.downloadFuncionarioDocumentoById({
      idFuncionarioArquivo,
    });
    return response;
  }

  async getFuncionarioTreinamentos(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<FuncionarioTreinamento>> {
    const response = await this.service.getFuncionarioTreinamentos({
      idFuncionario,
      page,
      pageSize,
    });
    return {
      ...response,
      items: response.items.map(
        (x): FuncionarioTreinamento => ({
          idFuncionarioTreinamento: x.idFuncionarioTreinamento,
          idTreinamento: x.idTreinamento,
          avaliarTreinamento: x.avaliarTreinamento,
          status: x.status,
          treinamento: x.nomeTreinamento,
          versao: x.versao,
          local: x.local,
          instrutor: x.instrutor ?? "",
          prazo: x.previAvaliacao,
          dataInicio: x.dataInicio ? dayjs(x.dataInicio).toDate() : null,
          dataPrevAvaliacao: x.dataPrevAvaliacao
            ? dayjs(x.dataPrevAvaliacao).toDate()
            : null,
          dataAvaliacao: x.dataAvaliacao
            ? dayjs(x.dataAvaliacao).toDate()
            : null,
          avaliador: x.avaliador ?? "",
          eficaz: x.eficaz,
          assinado: x.assinado,
          cargaHoraria: x.cargaHoraria,
          evidenciaObjetiva: x.evidenciaObjetiva,
        }),
      ),
    };
  }

  async createFuncionarioTreinamento(
    idFuncionario: number,
    idTreinamento: number,
    cargaHoraria: number,
    dataRealização: Date,
    instrutor: string,
    local: string,
    prazoAvaliacao: number,
  ): Promise<void> {
    await this.service.createAvaliacaoTreinamento({
      idFuncionario,
      idTreinamento,
      cargaHoraria,
      dataInicio: dataRealização,
      instrutor,
      local,
      prazoAvaliacao,
    });
  }

  async updateFuncionarioTreinamento(
    idFuncionarioTreinamento: number,
    idTreinamento: number,
    cargaHoraria: number,
    dataRealização: Date,
    instrutor: string,
    local: string,
    prazoAvaliacao: number,
  ): Promise<void> {
    await this.service.updateAvaliacaoTreinamento({
      idFuncionarioTreinamento,
      idTreinamento,
      cargaHoraria,
      dataInicio: dataRealização,
      instrutor,
      local,
      prazoAvaliacao,
    });
  }

  async deleteFuncionarioTreinamento(
    idFuncionarioTreinamento: number,
  ): Promise<void> {
    await this.service.deleteFuncionarioTreinamento({
      idFuncionarioTreinamento,
    });
  }

  async avaliarTreinamento(
    idFuncionarioTreinamento: number | null,
    idFuncionarioTreinamentoLote: number[] | null,
    eficaz: number,
    avaliador: string | null,
    dataAvaliacao: Date | null,
    evidenciaObjetiva: string | null,
    originScreen: number,
  ): Promise<void> {
    await this.service.avaliarTreinamento({
      idFuncionarioTreinamento,
      idFuncionarioTreinamentoLote,
      avaliador,
      dataAvaliacao,
      eficaz,
      evidenciaObjetiva,
      originScreen,
    });
  }

  async avaliarTreinamentoLote(
    idFuncionarioTreinamentoLote: number[],
    eficaz: number,
    avaliador: string | null,
    dataAvaliacao: Date | null,
    evidenciaObjetiva: string | null,
  ): Promise<void> {
    await this.service.avaliarTreinamentoLote({
      idFuncionarioTreinamentoLote,
      eficaz,
      avaliador,
      dataAvaliacao,
      evidenciaObjetiva,
    });
  }
  async getAllAvaliacaoTreinamentoLote(
    idCargo: number | null,
    idFuncionario: number | null,
    idCentroCusto: number[] | null,
    vencimentoDe: Date | null,
    vencimentoAte: Date | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<AvaliacaoTreinamento>> {
    return await this.service.getAllAvaliacaoTreinamentoLote({
      idCargo,
      idFuncionario,
      idCentroCusto,
      vencimentoDe,
      vencimentoAte,
      page,
      rowsPerPage,
    });
  }

  async getAllTreinamentoFuncionario(
    cargos: number[],
    centroCustos: number[],
    FornecedorPesquisa?: number,
  ): Promise<TreinamentoFuncionario[]> {
    const response = await this.service.getAllTreinamentoFuncionario({
      cargoIds: cargos,
      centroCustoIds: centroCustos,
      FornecedorPesquisa: FornecedorPesquisa,
    });
    return response.items;
  }
  async saveTreinamentoFuncionario(
    treinamentoIds: number[],
    funcionarioIds: number[],
    dataRealizacao: Date,
    local: string,
    instrutor: string,
    prazoAvaliacao: number,
  ): Promise<void> {
    await this.service.saveTreinamentoFuncionario({
      treinamentoIds,
      funcionarioIds,
      dataRealizacao,
      local,
      instrutor,
      prazoAvaliacao,
    });
  }
  async getAllTreinamentoFuncionarioTercData(): Promise<
    TreinamentoFuncionarioData[]
  > {
    const response = await this.service.getAllTreinamentoFuncionarioTercData(
      {},
    );
    return response.items;
  }
  async getAllTreinamentoFuncionarioTercInstrutor(
    data: string,
  ): Promise<TreinamentoFuncionarioInstrutor[]> {
    const response =
      await this.service.getAllTreinamentoFuncionarioTercInstrutor({ data });
    return response.items;
  }

  async getAllTreinamentoFuncionarioTercLocal(
    data: string,
    instrutor: string,
  ): Promise<TreinamentoFuncionarioLocal[]> {
    const response = await this.service.getAllTreinamentoFuncionarioTercLocal({
      data,
      instrutor,
    });
    return response.items;
  }
  //#endregion
  //#region Principal
  async getAllIndicadores(): Promise<TercIndicadores> {
    const response = await this.service.getAllIndicadores();
    return response.indicadores;
  }
  //#endregion

  async downloadContratoArquivo(idContratoArquivo: number): Promise<Blob> {
    return await this.service.downloadContratoArquivo({ idContratoArquivo });
  }
}
